import AreaVisualization from "views/components/visualizations/area/AreaVisualization";
import AreaVisualizationConfig from "views/logic/aggregationbuilder/visualizations/AreaVisualizationConfig";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import { DEFAULT_INTERPOLATION, interpolationTypes } from "views/Constants";
import {
  DEFAULT_AXIS_CONFIG,
  axisTypes,
  DEFAULT_AXIS_TYPE
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("Area chart");
const areaChart = {
  type: AreaVisualization.type,
  displayName: "Area Chart",
  component: AreaVisualization,
  config: {
    createConfig: () => ({
      interpolation: DEFAULT_INTERPOLATION,
      axisType: DEFAULT_AXIS_TYPE,
      axisConfig: DEFAULT_AXIS_CONFIG
    }),
    fromConfig: (config) => ({
      interpolation: config == null ? void 0 : config.interpolation,
      axisType: config == null ? void 0 : config.axisType,
      ...fromAxisConfig(config)
    }),
    toConfig: (formValues) => AreaVisualizationConfig.create(
      formValues.interpolation,
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "interpolation",
        title: "Interpolation",
        type: "select",
        options: interpolationTypes,
        required: true
      },
      {
        name: "axisType",
        title: "Axis Type",
        type: "select",
        options: axisTypes,
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default areaChart;
